import { postmultipart, post, form } from "@/utils/requestNoMessage";
import axios from "axios";

const TARGET_SERVER = process.env.VUE_ENV === "server";
const baseUrl = process.env.config.RRDH_HOST;

export default {
  getKeFu: getKeFu=> post("/kefu/admin/login/login.json"),
};
